module.exports = __webpack_public_path__ + "static/media/twitter-alt.0251d8ee.png";